import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { mainApi } from "../../api/axios";

/**
 * Get All KOTS
 */
export const getAllKots = createAsyncThunk(
  "kot/getAllKots",
  async (obj, { rejectWithValue }) => {
    try {
      const { storeId } = obj;
      const res = await mainApi.get(
        `/v1/pos/orders/kot-items?store_id=${storeId}&offset=0&limit=10`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

/**
 * Update kot status
 */
export const updateKotStatus = createAsyncThunk(
  "kot/updateKotStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await mainApi.patch(`v1/pos/orders/kot/status`, payload);
      return { ...res.data, order_kot_uid: payload.order_kot_uid };
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

// Slice
const orderSlice = createSlice({
  name: "kot",
  initialState: {
    kotList: [],
    activeCount: 0,
    loading: false,
    error: null,
  },
  reducers: {
    clearKotState: (state) => {
      state.kotList = [];
      state.activeCount = 0;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get All Kots
      .addCase(getAllKots.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllKots.fulfilled, (state, action) => {
        state.loading = false;
        state.kotList = action.payload;
        state.activeCount = action.payload.length;
      })
      .addCase(getAllKots.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update Kot Status
      .addCase(updateKotStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateKotStatus.fulfilled, (state, action) => {
        state.loading = false;
        const updatedKot = action.payload;
        state.kotList = state.kotList.filter(
          (kot) => kot.order_kot_uid !== updatedKot.order_kot_uid
        );
      })
      .addCase(updateKotStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearKotState } = orderSlice.actions;
export default orderSlice.reducer;
